import { Component, OnInit, ViewChild, ElementRef, Input, AfterViewInit } from '@angular/core';
import { Json2csvService } from 'csvtools-lib';
import { Chart } from 'chart.js';
import { MatDialog } from '@angular/material';
import { AudienceCapacity } from 'src/app/models/audience-models/audience-capacity.model';
import { TranslateService } from '@ngx-translate/core';
// import { DashboardTurnsWaitingTimeZoomCardComponent } from '../dashboard-turns-waiting-time-zoom-card/dashboard-turns-waiting-time-zoom-card.component';

@Component({
  selector: 'app-audience-capacity-capacity-chart-card',
  templateUrl: './audience-capacity-capacity-chart-card.component.html',
  styleUrls: ['./audience-capacity-capacity-chart-card.component.scss']
})
export class AudienceCapacityCapacityChartCardComponent implements OnInit, AfterViewInit {

  @ViewChild('capacityData', { static: false }) capacityDataRef: ElementRef;
  @Input() data: AudienceCapacity;
  @Input() colors;
  @Input() title;
  @Input() bigger;
  @Input() hideLegend;
  ctx;
  myChart;

  constructor(private translateService: TranslateService,
              private json2csvService: Json2csvService,
              private dialog: MatDialog
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.ctx = this.capacityDataRef.nativeElement.getContext('2d');
    this.render(this.data);
  }

  public statZoom() {
    // this.dialog.open(DashboardTurnsWaitingTimeZoomCardComponent, { data: { data: this.data, title: this.title, colors: this.colors } } );
  }

  private render(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const dataSets = new Array();
    // data.forEach((desk, i) => {
    //   dataSets.push({
    //     label: desk.deskName,
    //     data: desk.minutes,
    //     borderColor: this.colors[i],
    //     fill: false,
    //     borderWidth: 2,
    //     lineTension: 0.00
    //   });
    // });
    dataSets.push({
      label: this.translateService.instant('inputs'),
      data: data.countInto,
      borderColor: this.colors[0],
      fill: false,
      borderWidth: 2,
      lineTension: 0.00
    });
    dataSets.push({
      label: this.translateService.instant('outputs'),
      data: data.countExit,
      borderColor: this.colors[1],
      fill: false,
      borderWidth: 2,
      lineTension: 0.00
    });

    this.myChart = new Chart(this.ctx, {
      type: 'line',
      data: {
        datasets: dataSets,
        labels: ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.hideLegend ? false : true,
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa',
          labels: {
            padding: 5,
            boxWidth: 20,
            fontColor: '#aaaaaa'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              padding: 20,
              fontColor: '#aaaaaa',
              beginAtZero: true,
              callback: function(value, index, values) {
                return value;
              }
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#aaaaaa'
            }
          }]
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (t, chartData) => {
              if (t.yLabel !== 0) {
                return chartData.datasets[t.datasetIndex].label + ' · ' + t.yLabel;
              }
              return chartData.datasets[t.datasetIndex].label + ' · ' + 0;
            }
          }
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if (data.length === 0) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }

  public generateCSV() {
    const dataSet = [];
    // this.data.forEach(d => {
    //   dataSet.push([d.deskName, ...d.minutes]);
    // });
    dataSet.push([this.translateService.instant('inputs'), ...this.data.countInto]);
    dataSet.push([this.translateService.instant('outputs'), ...this.data.countExit]);
    this.json2csvService.setBody(dataSet, ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']);
    this.json2csvService.setHeader([this.translateService.instant('capacity'), '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00']);
    this.json2csvService.generateCSV('capacity-statistics');
  }

}

